import * as actionType from "../types/ActionTypes";

const initialState = {
  branches: [],
  postBranches: [],
  error: false,
  isLoading: false,
  isPostLoading: false,
  isUpdateLoading: false,
};

export const Branches = (state = initialState, action) => {
  switch (action.type) {
    case actionType.BRANCHES_SET_DATA:
      return {
        ...state,
        branches: action.branches,
        error: false,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };

    case actionType.BRANCHES_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.BRANCHES_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case actionType.BRANCHES_POST_LOADING:
      return {
        ...state,
        isPostLoading: true,
        error: false,
      };
    case actionType.BRANCHES_UPDATE_LOADING:
      return {
        ...state,
        isUpdateLoading: true,
        error: false,
      };
    case actionType.POST_BRANCHES_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.POST_BRANCHES_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        postBranches: action.postBranches,
      };
    case actionType.UPDATE_BRANCHES_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_BRANCHES_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_BRANCHES_DATA_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};
